export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.73.733h7.464c.294 0 .533.239.533.533l-.003 9.074H6.334V1.266c0-.294.238-.533.532-.533H8.85l3.51 4.37a.211.211 0 00.371-.138V.733zM6.796 14.88a.961.961 0 01-.463-.82v-.527h14.4v.52a.96.96 0 01-.47.826l-3.3 2.294a2.122 2.122 0 00-1.027 1.708v5.06a2.391 2.391 0 01-4.784.002v-4.987a2.13 2.13 0 00-1.022-1.776l-3.334-2.3z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "27",
    "height": "27",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};